import React, { Fragment, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from "@remix-run/react";
import { FullscreenPlayer } from './Player/FullscreenPlayer';
import { Swimlanes } from './Swimlanes/Swimlanes';
import { VideoInfo } from './VideoInfo/VideoInfo';
import { useSearchParams } from '../../../../play-core/hooks/use-search-params';
import { parseIntOrUndefined } from '../../../../play-core/utils/number-helper';
import { VerticalScrollTracker } from '../../analytics/VerticalScrollTracker';
import { loadVideoDetail } from '../../api/load-video-detail';
import { useLoadingBar } from '../../components/LoadingBar/LoadingBarProvider';
import { ErrorFallback } from '../../components/Message/ErrorFallback';
import { usePageTitle } from '../../components/Meta/PlayMetaData';
import { queryKeys } from '../../config/use-query';
import { usePath } from '../../config/VideoAppContext';
import { useAxios } from '../../hooks/use-axios';
import { useRouteState } from '../../hooks/use-route-state';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoDetailPage = ({
  initialData: {
    videoDetail: videoDetailInitial
  },
  isInitialLocation
}) => {
  const axios = useAxios();
  const {
    videoDetailPath
  } = usePath();
  const navigate = useNavigate();
  const {
    startTime: seekPosition,
    urn = ''
  } = useSearchParams();
  const startTime = parseIntOrUndefined(seekPosition);
  const [playbackUrn, setPlaybackUrn] = useState(urn);
  useEffect(() => {
    if (urn && playbackUrn !== urn) {
      setPlaybackUrn(urn);
    }
  }, [playbackUrn, urn]);
  const {
    squeezedVideoDetail
  } = useRouteState();
  const {
    data: videoDetailData,
    error,
    isLoading
  } = useQuery({
    queryKey: [queryKeys.VideoDetail(playbackUrn), axios],
    queryFn: () => loadVideoDetail(axios, playbackUrn),
    initialData: videoDetailInitial
  });
  const videoDetail = videoDetailData || squeezedVideoDetail;
  useLoadingBar(isLoading);
  useEffect(() => {
    if (videoDetail) {
      const newRoute = videoDetailPath(videoDetail, {
        startTime
      });
      const location = window.location.href;
      if (!location.includes(newRoute) && location.includes(videoDetail.urn)) {
        // replace to titled route
        navigate(newRoute, {
          replace: true
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoDetail, videoDetailPath]);
  const pageTitle = getVideoPageTitle(videoDetail);
  usePageTitle(pageTitle);
  return /*#__PURE__*/_jsxs(ErrorFallback, {
    hasError: error,
    children: [videoDetail && /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(VerticalScrollTracker, {
        pageTitle: pageTitle
      })
    }), /*#__PURE__*/_jsx(FullscreenPlayer, {
      videoDetail: videoDetail,
      isInitialLocation: isInitialLocation
    }), /*#__PURE__*/_jsx(VideoInfo, {
      videoDetail: videoDetail
    }), /*#__PURE__*/_jsx(Swimlanes, {
      videoDetail: videoDetail
    })]
  });
};
export const getVideoPageTitle = video => {
  if (video) {
    const isShowTitleInMedia = video.title.toLowerCase().includes(video.show?.title.toLowerCase() ?? '');
    return video.show?.title && !isShowTitleInMedia ? `${video.title} - ${video.show?.title}` : video.title;
  }
  return '';
};